import React from 'react';
import SideNavLayout from '@/layouts/SideNavLayout';

const ApplicationsIndexPage = () => {
  return (
    <SideNavLayout>
    </SideNavLayout>
  );
};

ApplicationsIndexPage.propTypes = {};

export default ApplicationsIndexPage;